// This icon file is generated automatically.
var PtoSearchOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M28.43 26.7L20.3 18.6a9.3 9.3 0 001.94-5.71c0-2.51-.98-4.86-2.75-6.63a9.3 9.3 0 00-6.63-2.75c-2.5 0-4.85.98-6.62 2.75a9.3 9.3 0 00-2.75 6.63c0 2.5.98 4.85 2.75 6.62a9.3 9.3 0 006.63 2.75 9.3 9.3 0 005.7-1.94l8.12 8.12c.1.1.26.1.36 0l1.37-1.36c.1-.1.1-.27 0-.37zm-10.6-8.88a6.96 6.96 0 01-9.9 0 6.96 6.96 0 010-9.9 6.96 6.96 0 019.9 0 6.96 6.96 0 010 9.9z", "fill-rule": "nonzero" } }] }, "name": "pto-search", "theme": "outlined" };
export default PtoSearchOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoSearchOutlined.js
// module id = 3929
// module chunks = 0